import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const waitTwoSeconds = () => new Promise(r => setTimeout(r, 2000));
const emailAIInsightsConfig = {
  id: 'email-ai-insight-coaching-tips',
  beforeEnter: waitTwoSeconds,
  tips: [{
    tipId: 'first-good-title-cell-insight-icon',
    attachTo: 'td div[data-polarity="true"]',
    placement: 'top right',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "emailAIInsights.title"
    }),
    steps: [{
      content: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "emailAIInsights.firstGood"
        })
      })
    }]
  }, {
    tipId: 'first-bad-title-cell-insight-icon',
    attachTo: 'td div[data-polarity="false"]',
    placement: 'top right',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "emailAIInsights.title"
    }),
    steps: [{
      content: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "emailAIInsights.firstBad"
        })
      })
    }]
  }, {
    tipId: 'insights-button',
    attachTo: '#insights-button',
    placement: 'top right',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "emailAIInsights.title"
    }),
    steps: [{
      content: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "emailAIInsights.insightsButton"
        })
      })
    }]
  }, {
    tipId: 'post-send-context-select',
    attachTo: '#post-send-insight-context-select-wrapper',
    placement: 'top right',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "emailAIInsights.title"
    }),
    steps: [{
      content: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "emailAIInsights.compareWithDropdown"
        })
      })
    }]
  }, {
    tipId: 'positive-spotlight-whats-happening',
    attachTo: '.spotlights-whats-happening-wrapper[data-polarity="true"]',
    placement: 'top right',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "emailAIInsights.title"
    }),
    steps: [{
      content: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "emailAIInsights.emailPositiveInsight"
        })
      })
    }]
  }, {
    tipId: 'negative-spotlight-whats-happening',
    attachTo: '.spotlights-whats-happening-wrapper[data-polarity="false"]',
    placement: 'top right',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "emailAIInsights.title"
    }),
    steps: [{
      content: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "emailAIInsights.emailNegativeInsight"
        })
      })
    }]
  }]
};
export default emailAIInsightsConfig;